import React, { useRef, useState } from "react";
import { Form, Alert } from "react-bootstrap";
import Button from "../../components/UI/Button/Button";
import { useAuth } from "../../contexts/AuthContext";
import { Link } from "react-router-dom";
import Container from "../../components/UI/Container/Container";
import Form__separator from "../../components/UI/Form/Form__separator/Form__separator";

export default function ForgotPassword() {
  const emailRef = useRef();
  const { resetPassword } = useAuth();
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setMessage("");
      setError("");
      setLoading(true);
      await resetPassword(emailRef.current.value);
      setMessage("Проверьте почту. Пароль сброшен.");
      window.scrollTo(0, 0);
    } catch {
      setError("Ошибка сброса пароля" );
      console.log(e);
      window.scrollTo(0, 0);
    }

    setLoading(false);
  }

  return (
    <>
      {error && <Alert variant="danger">{error}</Alert>}
      {message && <Alert variant="success">{message}</Alert>}
      <Form onSubmit={handleSubmit} className="Form Form_type_welcome-form">
        <h2 className="Heading Form__title">Забыли пароль?</h2>
        <Form.Group id="email" className="Form__group">
          <Form.Label>Email</Form.Label>
          <Form.Control type="email" ref={emailRef} required />
        </Form.Group>
        <Form.Group className="Form__group">
          <Button disabled={loading} className="Form__submit" type="submit">
            Сбросить
          </Button>
        </Form.Group>
        <Form.Group className="Form__group">
          <Form__separator />
        </Form.Group>
        <Link className="Form__link" to="/login">
          Войти с паролем (или google)
        </Link>
      </Form>
    </>
  );
}
